export default __webpack_public_path__ + "static/media/teeth_v2_bg.ab5219df.png";